module.exports = __webpack_public_path__ + "img/lock.174340d9.png";